import type {Inventory} from '../types';
import type {LocalizationService} from 'shared/providers/localization.provider';
import KpSearchInSearchContext from '../../search/kp-search/KpSearchInSearchContext.svelte';

export class MatchesController {
    public static controllerName = 'MatchesCtrl';

    public kpSearchInSearchContext = KpSearchInSearchContext;
    /*@ngInject*/
    constructor(public inventory: Inventory, private localizationService: LocalizationService) {
    }

    public getSearchTitle(): string {
        const msg = this.localizationService.get(/* @kp-localization inventory.Results */ 'inventory.Results');
        return `${msg} - ${this.inventory.text}`
    }
}
